module.exports = __webpack_public_path__ + "static/media/banner.83127f4d.jpg";